module.exports = __webpack_public_path__ + "media/favicon/apple-touch-icon-c861c793.png";